import Vue from 'vue';
import { hasProperty, getId, capitalizeText } from '@/helpers';
import { sendPdfToUser } from '@/helpers/pdfDownloadFunctions';

export const globalMixin = {
  methods: {
    hasProperty,
    getId,
    createdAt(object) {
      if (object.states.history !== []) {
        if (object.states.history.length > 0) {
          return object.states.history[0].date;
        }
        if (object.states.date !== undefined) {
          return object.states.date;
        }
        return undefined;
      }
      return object.states.date;
    },
    sendPatchRequest(url, body) {
      return this.axios.patch(url, body);
    },
    // helper method to update call_filter and proposal filter logic
    getParentById(id) {
      let component = null;
      let parent = this.$parent;
      while (parent && !component) {
        if (parent?.id === id) {
          component = parent;
        }
        parent = parent.$parent;
      }
      return component;
    },
    refreshProposalsFilter(proposals) {
      this.proposals = proposals;
      this.$emit('setup-proposal', this.proposals);
    },
    callChange(call) {
      // this method is used to change selected call in the parent
      this.selectedCall = call;
    },
    isTextValid(text, regex) {
      return (text === '') ? false : !!(regex.test(text));
    },
    capitalizeText,
    getDeepProp(obj, props) {
      return props.split('.').reduce((acc, p) => {
        // if the accumulator is something
        // then lookup the next nested property
        // otherwise return undefined
        if (acc === undefined) return '';
        if (this.hasProperty(acc, p)) {
          return acc[p];
        }
        return null;
      }, obj); // the initial accumulator is the object
    },
    generatePdf(id) {
      this.axios.get(`/render-pdf/${id}`, { responseType: 'arraybuffer' })
        .then((response) => {
          const url = response.request.responseURL;
          sendPdfToUser(url);
        });
    },
    async downloadDocumentPdf(objectId) {
      const response = await this.axios.get(`/documents/${objectId}/download-pdf`);
      const { msg } = response.data;
      if (msg) {
        this.$notify({ type: 'error', title: msg });
      } else {
        sendPdfToUser(response.request.responseURL);
      }
    },
    async downloadPdf(pdfId) {
      try {
        const response = await this.axios.get(`/documents/download/${pdfId}`);
        const { msg } = response.data;
        if (msg) {
          this.$notify({ type: 'error', title: msg });
        } else {
          sendPdfToUser(response.request.responseURL);
        }
      } catch {
        this.$notify({ type: 'error', title: 'Communication error' });
      }
    },
    downloadZip(...args) {
      const params = {};
      args.forEach((item) => {
        const entry = Object.entries(item)[0];
        const [key, value] = entry;
        params[key] = value;
      });
      return this.axios({
        url: `/documents/${this.infrastructure}/zip`,
        method: 'GET',
        responseType: 'blob',
        params,
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'proposals.zip');
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        });
    },
    closeModalEmit() {
      // emit signal to parent of modal components
      this.$emit('close-modal');
    },
    closeModalSlot() {
      // close modal by ref setup in the b-modal directive (this.modalRef)
      // must be set up the component data modalRef="ModalRef" and
      // :ref="modalRef" in the b-modal definition
      this.$refs[this.modalRef].hide();
    },
    isEmpty(obj) {
      if (obj === null || obj === undefined) return true;
      return Object.keys(obj).length === 0;
    },
    hexToRgb(hexColor) {
      const color = hexColor.replace('#', '');
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      return `rgb(${r},${g},${b})`;
    },
    emitSetupProposal(event) {
      this.$emit('setup-proposal', event);
    },
  },
};

Vue.mixin(globalMixin);
